import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import axios from '../axios/axios'; // Import axios from the correct location
import student from '../../Images/Students.jpg';
import './ApplicationForm.css'; // Import custom CSS for styling

const ApplicationForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    profile: '',
    mobile_number: '',
    email_id: '',
    add_info: '',
    resume: ''
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = e => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('profile', formData.profile);
      formDataToSend.append('mobile_number', formData.mobile_number);
      formDataToSend.append('email_id', formData.email_id);
      formDataToSend.append('add_info', formData.add_info);
      formDataToSend.append('resume', formData.resume);

      const response = await axios.post('send-mail', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setMessage(response.data.message);
      setError('');
      setValidationErrors({}); // Clear validation errors on success
      // Reset form after successful submission
      setFormData({
        name: '',
        profile: '',
        mobile_number: '',
        email_id: '',
        add_info: '',
        resume: ''
      });
    } catch (error) {
      const { response } = error;
      if (response && response.data.errors) {
        setValidationErrors(response.data.errors);
        setMessage('');
      } else {
        setError('An error occurred while submitting the form.');
      }
    }
  };

  return (
    <section className="contact-form-section">
      <Container>
        <Row>
          <Col lg={5}>
            <img
              className="img-responsive"
              src={student}
              width="500"
              height="540"
              style={{ marginTop: "20px" }}
              alt="Students"
            />
          </Col>
          <Col lg={6} className="mx-auto">
            {message && <Alert variant="success">{message}</Alert>}
            {error && <Alert variant="danger">{error}</Alert>}
            <Form id="contactForm" onSubmit={handleSubmit} encType="multipart/form-data" noValidate>
              <Form.Group controlId="name">
                <Form.Label>Name <span style={{ color: "#fe824c" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Please enter your name.."
                  isInvalid={!!validationErrors.name}
                  required
                />
                {validationErrors.name && <Form.Control.Feedback type="invalid">{validationErrors.name[0]}</Form.Control.Feedback>}
              </Form.Group>

              <Form.Group controlId="profile">
              <Form.Label>Apply For <span style={{ color: "#fe824c" }}>*</span></Form.Label>
              <Form.Control
                as="select"
                name="profile"
                value={formData.profile}
                onChange={handleChange}
                isInvalid={!!validationErrors.profile}
                required
              >
                <option value="">Please select a profile</option>
                <option value="Administration">Sales</option>
                <option value="Finance">Marketing</option>
                <option value="Finance">Finance</option>
                <option value="Human Resources">Human Resources</option>
                <option value="IT">IT</option>
              </Form.Control>
              {validationErrors.profile && <Form.Control.Feedback type="invalid">{validationErrors.profile[0]}</Form.Control.Feedback>}
            </Form.Group>
            

              <Form.Group controlId="mobile_number">
                <Form.Label>Mobile Number <span style={{ color: "#fe824c" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleChange}
                  placeholder="Please enter mobile number.."
                  isInvalid={!!validationErrors.mobile_number}
                  required
                />
                {validationErrors.mobile_number && <Form.Control.Feedback type="invalid">{validationErrors.mobile_number[0]}</Form.Control.Feedback>}
              </Form.Group>

              <Form.Group controlId="email_id">
                <Form.Label>Email Id <span style={{ color: "#fe824c" }}>*</span></Form.Label>
                <Form.Control
                  type="email"
                  name="email_id"
                  value={formData.email_id}
                  onChange={handleChange}
                  placeholder="Please enter email-id.."
                  isInvalid={!!validationErrors.email_id}
                  required
                />
                {validationErrors.email_id && <Form.Control.Feedback type="invalid">{validationErrors.email_id[0]}</Form.Control.Feedback>}
              </Form.Group>

              <Form.Group controlId="add_info">
                <Form.Label>Additional information</Form.Label>
                <Form.Control
                  as="textarea"
                  name="add_info"
                  rows={4}
                  value={formData.add_info}
                  onChange={handleChange}
                  placeholder="Please enter additional information.."
                />
              </Form.Group>

              <Form.Group controlId="resume">
                <Form.Label>Upload Resume <span style={{ color: "#fe824c" }}>*</span></Form.Label>
                <Form.Control
                  type="file"
                  name="resume"
                  onChange={handleFileChange}
                  isInvalid={!!validationErrors.resume}
                  required
                />
                {validationErrors.resume && <Form.Control.Feedback type="invalid">{validationErrors.resume[0]}</Form.Control.Feedback>}
              </Form.Group>

              <div className="button-group">
                <Button variant="primary" type="submit" className="custom-button">Submit</Button>
                <Button variant="secondary" type="reset" className="custom-button">Reset</Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ApplicationForm;
